import { render } from "./NovedadesGastosHrbp.vue?vue&type=template&id=3c1ef485"
import script from "./NovedadesGastosHrbp.vue?vue&type=script&lang=js"
export * from "./NovedadesGastosHrbp.vue?vue&type=script&lang=js"

import "./NovedadesGastosHrbp.vue?vue&type=style&index=0&id=3c1ef485&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__